import { useNavigate } from 'react-router-dom'

import { useMfaVerify } from '../hooks/useMfaVerify'
import { MfaBackupStep, MfaCodeStep, MfaMethodSelectStep } from './MfaSteps'

/** Krok MFA w logowaniu (/auth/mfa-verify) — prezentacja z
 *  `app/prototypes/src/features/auth/components/MfaVerify.tsx`.
 *  Orkiestracja, guard sesji MFA i integracja z Reduxem zostają w `useMfaVerify`. */
export const MfaVerify = () => {
  const navigate = useNavigate()
  const {
    step,
    code,
    setCode,
    backupCode,
    setBackupCode,
    verifyError,
    isSubmitting,
    isSendingEmail,
    resendSecondsLeft,
    hasMultipleMethods,
    sendEmailAndGoToStep,
    resendEmailCode,
    handleVerify,
    goToBackup,
    goToSelect,
    goToTotpFromSelect,
    goBackFromBackup,
  } = useMfaVerify()

  const backToLogin = () => navigate('/auth/login', { replace: true })

  return (
    <section className='w-full max-w-crane-card rounded-crane-md bg-crane-card p-3 md:p-6 shadow-crane-soft'>
      {step === 'select' ? (
        <MfaMethodSelectStep
          isSendingEmail={isSendingEmail}
          onSelectEmail={sendEmailAndGoToStep}
          onSelectTotp={goToTotpFromSelect}
        />
      ) : null}

      {step === 'totp' || step === 'email' ? (
        <MfaCodeStep
          method={step === 'email' ? 'EMAIL' : 'TOTP'}
          code={code}
          setCode={setCode}
          isSubmitting={isSubmitting}
          isSendingEmail={isSendingEmail}
          resendSecondsLeft={resendSecondsLeft}
          hasMultipleMethods={hasMultipleMethods}
          onVerify={() => handleVerify(step === 'email' ? 'EMAIL' : 'TOTP', code)}
          onResend={step === 'email' ? resendEmailCode : undefined}
          onGoBackupStep={() => goToBackup(step)}
          onGoSelectStep={hasMultipleMethods ? goToSelect : undefined}
          onGoBack={backToLogin}
          error={verifyError}
        />
      ) : null}

      {step === 'backup' ? (
        <MfaBackupStep
          backupCode={backupCode}
          setBackupCode={setBackupCode}
          isSubmitting={isSubmitting}
          onVerify={() => handleVerify('BACKUP_CODE', backupCode)}
          onGoBack={goBackFromBackup}
          error={verifyError}
        />
      ) : null}
    </section>
  )
}
